// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --development` replaces `environment.ts` with `environment.dev.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  image_path: "https://staging.rapidise.co/customer/assets/images/",
  file_path: "https://staging.rapidise.co/customer/assets/file/",
  quote_url: 'https://staging.rapidise.co/quotebk/api/mquotation/v3/',
  quote_auth_url: 'https://staging.rapidise.co/quotebk/api/muser/v3/',
  equote_url: 'https://staging.rapidise.co/quotebk/api/equotation/v3',
  auth_url: 'https://staging.rapidise.co/authbk/api',
  customer_login_page: "https://staging.rapidise.co/customer/accounts/login",
  project_management_url: "https://staging.rapidise.co/pmbk/api",
  customer_domain: "https://staging.rapidise.co/customer/quotations",
  member_domain:"https://staging.rapidise.co/internal",
  socket_Url:'https://staging.rapidise.co/quotebk/',
  toastrTimeOutInSec: 4000,
  crypto_js: {
    key: "sIBFdhVq3t3AsdYsNM",
  },
  firebase_registration_path : "firebase-messaging-sw.js",
  firebaseConfig: {
    apiKey: "AIzaSyC6MRthA4EGqnnJS7GoEU8Pm66xDIsMAcQ",
    authDomain: "fir-teksun.firebaseapp.com",
    projectId: "fir-teksun",
    storageBucket: "fir-teksun.appspot.com",
    messagingSenderId: "211772338775",
    appId: "1:211772338775:web:b92c20642608b8f7992912",
    measurementId: "G-22SFFZZNSD"
}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
